import CareHubScreen from '@/karehero-app/care/CareHubScreen';
import { CARE_HUB_SLIDES } from '@/karehero-app/care/CareHub.content';
import OnboardingWalkthrough from '@/karehero-app/tell-us-once/walkthrough/OnboardingWalkthrough';
import {
  calculatorChat,
  calculatorResults,
} from '@/karehero-app/handover/benefits-calculator-1-0';

// The top row's screens, as the flows page opens them, so the deck and the
// page cannot show different things.
const base = { grid: true, tidy: true, subjects: true } as const;
const SCREENS = {
  // Margaret before the check, so the Home and the chat beside it are about
  // the same person.
  homeCheck: () => <CareHubScreen {...base} unchecked nudge='check' />,
  calculator: calculatorChat,
  results: calculatorResults,
  // Where See your results lands: Money, with the results in it.
  moneyResults: () => <CareHubScreen {...base} initialArea='money' />,
  first: () => <CareHubScreen {...base} solo emptyCircle />,
  home: () => <CareHubScreen {...base} />,
  before: () => <CareHubScreen {...base} initialPerson='Brian' nudge='check' />,
  moneyBefore: () => (
    <CareHubScreen {...base} initialPerson='Brian' initialArea='money' />
  ),
  moneyAfter: () => <CareHubScreen {...base} initialArea='money' />,
  arranging: () => <CareHubScreen {...base} initialArea='arranging' />,
  legal: () => <CareHubScreen {...base} initialArea='legal' />,
  legalHas: () => <CareHubScreen {...base} initialArea='legal' hasPoa />,
  record: () => <CareHubScreen {...base} initialArea='record' />,
};

/**
 * CONCEPT. The Care hub, presented: the onboarding walkthrough's deck with the
 * hub in the phone, a slide a screen, each with the reasoning from the flows
 * page. Back and Next, or the arrow keys; the phone can still be clicked.
 */
const CareHubWalkthrough = () => (
  <OnboardingWalkthrough slides={CARE_HUB_SLIDES} screens={SCREENS} />
);

export default CareHubWalkthrough;
